import { useSolvSelector } from '~/reducers';
import { useLocationGeneralConfigs } from '~/hooks/useLocationGeneralConfigs';

export const useShouldShowAddressValidation = (locationId: string): boolean => {
  const paperwork = useSolvSelector((state) => state.paperwork);
  const { data: locationGeneralConfigsData } = useLocationGeneralConfigs(
    locationId,
    ['isAddressValidationEnabled'],
    true
  );

  return (
    !!locationGeneralConfigsData?.isAddressValidationEnabled &&
    !paperwork.hasPaperworkAddressValidationError
  );
};
